import ClassicEditor from '@ckeditor/ckeditor5-editor-classic/src/classiceditor';
import Essentials from '@ckeditor/ckeditor5-essentials/src/essentials';
import Paragraph from '@ckeditor/ckeditor5-paragraph/src/paragraph';
import Heading from '@ckeditor/ckeditor5-heading/src/heading';
import Bold from '@ckeditor/ckeditor5-basic-styles/src/bold';
import Italic from '@ckeditor/ckeditor5-basic-styles/src/italic';
import Underline from '@ckeditor/ckeditor5-basic-styles/src/underline';
import Strikethrough from '@ckeditor/ckeditor5-basic-styles/src/strikethrough';
import BlockQuote from '@ckeditor/ckeditor5-block-quote/src/blockquote';
import Link from '@ckeditor/ckeditor5-link/src/link';
import List from '@ckeditor/ckeditor5-list/src/list';
import Indent from '@ckeditor/ckeditor5-indent/src/indent';
import Image from '@ckeditor/ckeditor5-image/src/image';
import ImageCaption from '@ckeditor/ckeditor5-image/src/imagecaption';
import ImageStyle from '@ckeditor/ckeditor5-image/src/imagestyle';
import ImageToolbar from '@ckeditor/ckeditor5-image/src/imagetoolbar';
import ImageUpload from '@ckeditor/ckeditor5-image/src/imageupload';
import Table from '@ckeditor/ckeditor5-table/src/table';
import TableToolbar from '@ckeditor/ckeditor5-table/src/tabletoolbar';
import MediaEmbed from '@ckeditor/ckeditor5-media-embed/src/mediaembed';
import PasteFromOffice from '@ckeditor/ckeditor5-paste-from-office/src/pastefromoffice';
import TextTransformation from '@ckeditor/ckeditor5-typing/src/texttransformation';
import SourceEditing from '@ckeditor/ckeditor5-source-editing/src/sourceediting';
import HtmlSupport from '@ckeditor/ckeditor5-html-support/src/generalhtmlsupport';


export const TOOLBAR_PRESETS = {
    base:   ['bold','italic','underline','|','link','|','bulletedList','numberedList','|','undo','redo'],
    small:  ['heading','|','bold','italic','underline','|','link','blockQuote','|','bulletedList','numberedList','|','undo','redo'],
    medium: ['heading','|','bold','italic','underline','strikethrough','|','link','blockQuote','|','bulletedList','numberedList','indent','outdent','|','imageUpload','|','undo','redo'],
    large:  ['heading','|','bold','italic','underline','strikethrough','|','link','blockQuote','|','bulletedList','numberedList','indent','outdent','|','imageUpload','mediaEmbed','insertTable','|','undo','redo'],
    full:   ['heading','|','bold','italic','underline','strikethrough','|','link','blockQuote','|','bulletedList','numberedList','indent','outdent','|','imageUpload','mediaEmbed','insertTable','|','sourceEditing','|','undo','redo']
};

ClassicEditor.builtinPlugins = [
    Essentials, Paragraph, Heading, Bold, Italic, Underline, Strikethrough,
    BlockQuote, Link, List, Indent, Image, ImageCaption, ImageStyle, ImageToolbar,
    ImageUpload, Table, TableToolbar, MediaEmbed, PasteFromOffice, TextTransformation,
    SourceEditing, HtmlSupport
];

ClassicEditor.defaultConfig = {
    toolbar: {
        items: TOOLBAR_PRESETS.base
    },
    image: { toolbar: ['imageStyle:full', 'imageStyle:side', '|', 'imageTextAlternative'] },
    table: { contentToolbar: ['tableColumn', 'tableRow', 'mergeTableCells'] },
    language: 'it',
    // Aggiungi questa sezione
    htmlSupport: {
        allow: [
            {
                name: 'div',
                attributes: true,
                styles: true,
                classes: true
            },
            {
                name: 'span',
                attributes: true,
                styles: true,
                classes: true
            },
            {
                name: 'table',
                attributes: true,
                styles: true,
                classes: true,
                children: true
            },
            {
                name: 'tr',
                attributes: true,
                styles: true,
                classes: true,
                children: true
            },
            {
                name: 'td',
                attributes: true,
                styles: true,
                classes: true,
                children: true
            },
            {
                name: 'th',
                attributes: true,
                styles: true,
                classes: true,
                children: true
            },
            {
                name: 'p',
                attributes: true,
                styles: true,
                classes: true
            },
            {
                name: 'h1',
                attributes: true,
                styles: true,
                classes: true
            },
            {
                name: 'h2',
                attributes: true,
                styles: true,
                classes: true
            },
            {
                name: 'h3',
                attributes: true,
                styles: true,
                classes: true
            },
            {
                name: 'img',
                attributes: ['src', 'alt', 'width', 'height', 'style'],
                styles: true,
                classes: true
            },
            {
                name: 'a',
                attributes: ['href', 'title', 'target'],
                styles: true,
                classes: true
            },
            {
                name: 'ul',
                attributes: true,
                styles: true,
                classes: true,
                children: true
            },
            {
                name: 'ol',
                attributes: true,
                styles: true,
                classes: true,
                children: true
            },
            {
                name: 'li',
                attributes: true,
                styles: true,
                classes: true,
                children: true
            },
            {
                name: 'br'
            },
            {
                name: 'hr'
            }
        ]
    }
};

export default ClassicEditor;
